export const REQUEST_BASE_URL = 'https://n.b2b.globalph.cn/api/'
export const SOCKET_BASE_URL = 'ws://n.b2b.globalph.cn/api/cozeAIWs'
// export const SOCKET_BASE_URL = 'ws://uat.n.b2b.globalph.cn/api/cozeAIWs'


